import { useState } from 'react';
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { getActiveAlerts, acknowledgeAlert } from '@/services/ops.service';

export function useAlerts() {
  const qc = useQueryClient();
  const [severityFilter, setSeverityFilter] = useState<string | null>(null);
  const query = useQuery({ queryKey: ['alerts'], queryFn: () => getActiveAlerts(), refetchInterval: 30_000 });
  const ackMutation = useMutation({
    mutationFn: (alertId: string) => acknowledgeAlert(alertId),
    onSuccess: () => { void qc.invalidateQueries({ queryKey: ['alerts'] }); },
  });

  const allAlerts = query.data?.data ?? [];
  const filtered = severityFilter ? allAlerts.filter((a) => a.severity === severityFilter) : allAlerts;

  return { alerts: filtered, allAlerts, isLoading: query.isLoading, isError: query.isError, refetch: query.refetch, acknowledge: ackMutation.mutate, isAcknowledging: ackMutation.isPending, severityFilter, setSeverityFilter };
}
